import {
    useMutation,
} from '@tanstack/react-query'

import requests from 'app/requests/LongTermLease/BookedContainer.requests'
import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import {
    RejectContainersRequestData,
} from '../longTermLease.types'

const useRejectContainers = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessLongTermLeaseUpdate,
        onError,
    } = useHandleStatusRequest({
        title: 'Container(s) Rejected',
        id: 'RejectDedicatedContainers',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            longTermLeaseId, data,
        }:{longTermLeaseId: number, data: RejectContainersRequestData[]}) => {
            return simpleApi({
                ...requests.rejectContainers({
                    longTermLeaseId,
                    data: {
                        rejectedBookedContainers: data,
                    },
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessLongTermLeaseUpdate,
    })
}

export default useRejectContainers
